import '@fortawesome/fontawesome-free/css/all.min.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppJaven from './JavenHome';

const root = ReactDOM.createRoot(document.getElementById('root'));
const hostname = window.location.hostname;

// Conditional rendering based on the hostname
const renderApp = hostname === 'javenl.com' ? <AppJaven /> : <App />;

root.render(
  renderApp
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
